import * as React from 'react'
export const Bd = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 85.333 513 342" width="1em" height="1em" {...props}>
    <path fill="#2d6e41" d="M0 85.331h513v342H0z" />
    <circle cx={218.902} cy={256.5} r={115} fill="#F40B32" />
  </svg>
)
